import React from 'react';
import { useTranslation } from 'react-i18next';

interface PowerOutageScheduleFilterSubmitButtonProps {
  testId?: string;
  className?: string;
  onSubmit?: () => void;
}

export const PowerOutageScheduleFilterSubmitButton: React.FC<
  PowerOutageScheduleFilterSubmitButtonProps
> = ({ testId, className, onSubmit }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onSubmit}
      data-testId={testId}
      className={`noto-11-medium flex h-[24px] w-[50px] cursor-pointer items-center justify-center rounded-[5px] bg-teal-main text-white ${className}`}
    >
      {t('overview.modal.filter.submit')}
    </div>
  );
};
